import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis } from "recharts";

import { getRandomIntInclusive } from "@intelligems/ig-utils";
import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";

interface IgHorizStackedBarChartSkeletonProps {
  useLargeDataset?: boolean;
}

export const IgHorizStackedBarChartSkeleton = ({
  useLargeDataset,
}: IgHorizStackedBarChartSkeletonProps) => {
  const theme = useTheme();
  const fakeBarData = Array(useLargeDataset ? 12 : 2)
    .fill("")
    .map(() => ({
      name: "fake",
      value: getRandomIntInclusive(1, 5),
      value2: getRandomIntInclusive(1, 5),
    }));
  return (
    <Grid>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={fakeBarData} layout={"vertical"}>
          <XAxis
            type="number"
            domain={[0, 100]}
            tickLine={false}
            tick={false}
            axisLine={false}
          />
          <YAxis
            axisLine={{ stroke: theme.igBorders.core.disabled }}
            type={"category"}
            dataKey={"variation_id"}
            tickLine={false}
            tick={false}
          />
          <Bar
            dataKey="value"
            stackId="a"
            fill={theme.igPrimitives.gray["A100"]}
            className="infinite-pulsing"
          />
          <Bar
            dataKey="value2"
            stackId="a"
            fill={theme.igPrimitives.gray["A200"]}
            className="infinite-pulsing"
          />
        </BarChart>
      </ResponsiveContainer>
    </Grid>
  );
};
